import { toast } from "react-toastify";
import * as React from "react";
import { useContext } from "react";
import { DataResult } from "@progress/kendo-data-query";
import PageMenuItem from "../../../../../Layout/PageMenu/PageMenuItem";
import { EditProjectContext } from "../../../EditProjectContext";
import { LtlPipelineViewModel } from "../../../../ViewModel/LtlPipelineViewModel";
import { LtlRoutingViewModel } from "../../../../ViewModel/LtlRoutingViewModel";
import { getActiveLtlRouting } from "./GetActiveLtlRouting";
import { ProjectState } from "../../../../ViewModel/ProjectState";
import { SpdrClientViewModel } from "../../../../ViewModel/SpdrClientViewModel";
import { isSpdr } from "../IsSpdr";
import { isPdsr } from "../IsPdsr";
import { PdsrClientViewModel } from "../../../../ViewModel/PdsrClientViewModel";
import { isDisabledForSpdr } from "./IsDisabledForSpdr";
import { isDisabledForPdsr } from "./IsDisabledForPdsr";

type AddActiveRoutingButtonProps = {
  ltlPipeline: LtlPipelineViewModel | undefined;
  onDataReceived: (newDataResult: DataResult) => void;
  disabled: boolean;
};

export function AddActiveRoutingButton({
  ltlPipeline,
  onDataReceived,
  disabled,
}: AddActiveRoutingButtonProps) {
  const { project, stopDataOfSpdrsOrPdsrs, selectedLtlSpdrOrPdsr } = useContext(EditProjectContext);

  const onActiveRoutingButtonClick = async () => {
    const routing = await toast.promise(getActiveLtlRouting(project, ltlPipeline), {
      pending: "loading",
      error: "Could not retrieve active Routing",
    });

    if (!routing || routing.length === 0) {
      toast("No active Routing found", {
        type: "info",
      });
    } else {
      toast("Active Routing added", {
        type: "success",
      });
      addActiveRouting(routing);
    }
  };

  function isButtonDisabled(): boolean {
    if (project.State !== ProjectState.Sandbox) {
      return true;
    }

    if (isSpdr(selectedLtlSpdrOrPdsr)) {
      return isDisabledForSpdr(
        (selectedLtlSpdrOrPdsr as SpdrClientViewModel).SpdrId,
        project,
        stopDataOfSpdrsOrPdsrs,
        ltlPipeline
      );
    }

    if (isPdsr(selectedLtlSpdrOrPdsr)) {
      return isDisabledForPdsr(
        (selectedLtlSpdrOrPdsr as PdsrClientViewModel).PdsrId,
        project,
        stopDataOfSpdrsOrPdsrs,
        ltlPipeline
      );
    }
    throw Error("No Implementation");
  }

  const addActiveRouting = (routing: Array<LtlRoutingViewModel>) => {
    onDataReceived({ data: routing, total: routing.length });
  };

  return (
    <PageMenuItem
      align="left"
      color="primary"
      type="button"
      onClick={onActiveRoutingButtonClick}
      disabled={isButtonDisabled() || disabled}
    >
      Add Active Routing
    </PageMenuItem>
  );
}
